.optionContent {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  padding: 8px 48px 8px 16px;
  text-decoration: none;
  text-align: left;
  border: 0;
  cursor: pointer;
  user-select: none;
  border-radius: 0;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
}

.optionText {
  flex: 1 1 auto;
  min-width: 0;
  margin-top: 4px;
  margin-bottom: 4px;
}

.secondaryAction {
  top: 50%;
  right: 16px;
  position: absolute;
  transform: translateY(-50%);
}
